import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const searchLocationsCitysAPI = createApi({
  reducerPath: 'SearchLocationsCitysAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/Campaign' }),
  endpoints: (build) => ({
    fetchSearchLocationsCitys: build.query({
      query: (inputString) => ({
        url: `/GetSearchLocations?term=${inputString}`,
        method: 'GET',
      }),
      transformResponse: (response) => response.filter(({ type }) => type !== 'continent'),
    }),
    fetchSearchLocationsCitys1: build.query({
      query: () => ({
        url: `/GetSearchLocations`,
        method: 'GET',
      }),
    }),
    getInitLocationsList: build.query({
      query: () => ({
        url: `/GenerateContriesWithRegions`,
        method: 'GET',
      }),
    }),
  }),
});
